import { Auth } from "aws-amplify";
import { useEffect, useState } from "react";

export interface CurrentUser {
  attributes: {
    email: string;
    [key: string]: unknown;
  };
  [key: string]: unknown;
}

type CurrentUserState = {
  user: CurrentUser | null;
  loading: boolean;
  error: unknown | null;
};

const useCurrentUser = () => {
  const [state, setState] = useState<CurrentUserState>({
    user: null,
    loading: true,
    error: null
  });

  useEffect(() => {
    let isCancelled = false;

    const fetchUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        if (!isCancelled) {
          setState({ user, loading: false, error: null });
        }
      } catch (error) {
        if (!isCancelled) {
          setState({ user: null, loading: false, error });
        }
      }
    };

    fetchUser();
    return () => {
      isCancelled = true;
    };
  }, []);

  return state;
};

export default useCurrentUser;
